import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import ShortFormattedDate from '../../../shared/ShortFormattedDate';

export default function CheckedOutDueOn({ isDigital, dueDate }) {
  return (
    <div className="cp-checked-out-due-on">
      <FormattedMessage
        id={isDigital ? 'digital_expires_on_date' : 'due_by_date'}
        values={{ date: <ShortFormattedDate value={dueDate} /> }} />
    </div>
  );
}

CheckedOutDueOn.propTypes = {
  isDigital: PropTypes.bool,
  dueDate: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutDueOn/CheckedOutDueOn.jsx